import React from "react";
import { Outlet } from "react-router-dom";
import Layout from "../../layout/Layout";

const TemplateMessage = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default TemplateMessage;
